import ThisModule from "./ErrorBanner";

export default ThisModule;
